import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import clsx from 'clsx';
import { Box, Button, Card, Typography, useMediaQueries } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { IntroStep } from './components/IntroStep/IntroStep';
import { OnboardingLayout } from './components/OnboardingLayout/OnboardingLayout';
import { useOnboardingFlow } from './hooks/useOnboardingFlow';
import styles from './VendorOnboarding.module.scss';
export const GetVendorOnboardingTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const VendorOnboarding = (param)=>{
    let { testId, onComplete } = param;
    const testIds = useMemo(()=>GetVendorOnboardingTID(testId), [
        testId
    ]);
    const skipInviteTeam = false;
    const { currentStep, progress, isSkippableStep, goNext, goBack } = useOnboardingFlow({
        skipInviteTeam
    });
    const { mobile: isMobile, smallerThanTablet: isTablet } = useMediaQueries();
    const handleContinue = ()=>{
        if (currentStep === 'closing') {
            onComplete();
            return;
        }
        goNext();
    };
    const isWaitingOrClosing = currentStep === 'waiting' || currentStep === 'closing';
    const handleIntroComplete = ()=>{
        goNext();
    };
    const renderStepContent = ()=>{
        if (currentStep === 'intro') {
            return /*#__PURE__*/ _jsx(IntroStep, {
                onSkip: handleIntroComplete,
                onComplete: handleIntroComplete
            });
        }
        if (isWaitingOrClosing) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: testIds.VendorOnboardingTestIds.StepContent(),
                        children: currentStep
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        skin: "primary",
                        onClick: handleContinue,
                        testId: testIds.VendorOnboardingTestIds.NextButton(),
                        children: "Next"
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsx(OnboardingLayout, {
            progress: progress,
            onBack: currentStep !== 'businessDetailsA' ? goBack : undefined,
            onContinue: handleContinue,
            showSkipButton: isSkippableStep,
            onSkip: goNext,
            children: /*#__PURE__*/ _jsx(Typography, {
                testId: testIds.VendorOnboardingTestIds.StepContent(),
                children: currentStep
            })
        });
    };
    return /*#__PURE__*/ _jsx(Box, {
        className: clsx(styles.root, isMobile && styles.mobile, isTablet && styles.tablet),
        testId: testIds.VendorOnboardingTestIds.Root(),
        children: /*#__PURE__*/ _jsx(Card, {
            className: styles.card,
            borderSkin: "default",
            borderRadius: "m",
            children: renderStepContent()
        })
    });
};
